import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { EventEmitter } from '@angular/core';

export const onDrop = (
  { previousIndex, currentIndex }: CdkDragDrop<Array<{ [key: string]: any }>>,
  recordList: any[],
  reportReordered: EventEmitter<any>
) => {
  recordList = recordList.slice();
  const positions = recordList.map(({ position }) => position);
  // MoveItemInArray move the item to the right place but does not update the position value
  moveItemInArray(recordList, previousIndex, currentIndex);
  // Update the position values on each item
  recordList = recordList.map((record, index) => ({ ...record, position: positions[index] }));
  reportReordered.emit(recordList);
};
